import {CustomError} from '../../../libs/shared/helpers/src/types/customErrors';

/** We're offline and we want to retry later when we're online. */
export class OfflineError extends CustomError {
  constructor(originalError?: Error) {
    super();

    this.originalError = originalError;
  }

  readonly originalError: Error | undefined;
}
